import { Wand2, Loader2, Check, ImageIcon, RefreshCw } from "lucide-react";
import StylePicker from "./StylePicker";

export default function VoiceVisualControls({
  scenes = [],
  allImgLoading,
  onAllImages,
  style = "cinematic",
  onStyleChange,
}) {
  const totalScenes = scenes.length;
  const imagesDone = scenes.filter((s) => s.has_image).length;
  const imagesRemaining = Math.max(0, totalScenes - imagesDone);
  const allReady = imagesRemaining === 0 && totalScenes > 0;

  return (
    <div className="border border-white/10 rounded-md bg-[#121212] p-5 space-y-3" data-testid="generation-panel">
      <div className="flex items-start gap-2">
        <ImageIcon className="h-4 w-4 text-blue-400 mt-0.5 shrink-0" />
        <div>
          <p className="text-sm font-semibold text-zinc-200">Scene visuals <span className="text-zinc-500 font-normal">· optional</span></p>
          <p className="text-xs text-zinc-500 mt-0.5">
            Pick a visual style, then generate AI images for a richer look before you tap <span className="text-zinc-300">Create your video</span>.
          </p>
        </div>
      </div>

      <div>
        <label className="block text-xs uppercase tracking-[0.15em] text-zinc-500 mb-1.5">Visual style</label>
        <StylePicker value={style} onChange={(v) => onStyleChange?.(v)} disabled={allImgLoading || !onStyleChange} testid="visual-style-select" />
      </div>

      <button
        onClick={() => onAllImages(false)}
        disabled={allImgLoading || allReady}
        data-testid="generate-all-images-btn"
        className="w-full inline-flex items-center justify-center gap-2 bg-white/5 border border-white/10 hover:bg-white/10 px-4 py-2.5 rounded-md text-sm font-semibold transition-colors disabled:opacity-60"
      >
        {allImgLoading ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : allReady ? (
          <Check className="h-4 w-4 text-green-400" />
        ) : (
          <Wand2 className="h-4 w-4" />
        )}
        {allReady ? "All visuals ready" : `Generate AI visuals${totalScenes ? ` (${imagesDone}/${totalScenes})` : ""}`}
      </button>

      {imagesDone > 0 && (
        <button
          onClick={() => onAllImages(true)}
          disabled={allImgLoading}
          data-testid="regenerate-all-images-btn"
          className="w-full inline-flex items-center justify-center gap-2 text-xs text-blue-300 hover:text-blue-200 py-1.5 transition-colors disabled:opacity-50"
        >
          <RefreshCw className={`h-3.5 w-3.5 ${allImgLoading ? "animate-spin" : ""}`} />
          Regenerate all {totalScenes} scenes in this style ({totalScenes * 5} credits)
        </button>
      )}
    </div>
  );
}
